/**
 * Do NOT MODIFY THIS FILE OR ANY OTHER FILE IN THE __generated__ DIRECTORY.
 *
 * Generated using StyleDictionary on Tue, 03 Nov 2026 06:08:19 GMT.
 */

export const lightThemeRaw = {
  colors: {
    background: '#ffffff',
    text: '#181a20',
    primary: '#5a3fff',
    secondary: '#0a004a',
    brand: '#F84184',
    accent: '#df322a',
    danger: '#c0000c',
    warning: '#835500',
    success: '#006d3b',
    info: '#0062a0',
    variant: [
      '#BDE7FF',
      '#B1FAE0',
      '#FFF0B3',
      '#FFB7B2',
      '#FFB1D8',
      '#CBC1F4',
      '#AFD5FF',
    ],
  },
  components: {
    badge: {
      bold: {
        primary: { surfaceColor: '#e1daff' },
        'primary-inverse': { surfaceColor: '#ffffff' },
        secondary: { surfaceColor: '#e1daff' },
        'secondary-inverse': { surfaceColor: '#ffffff' },
        neutral: { surfaceColor: '#d2d8ea' },
        'neutral-inverse': { surfaceColor: '#E6EAFA' },
        critical: { surfaceColor: '#ffdad5' },
        'critical-inverse': { surfaceColor: '#ffffff' },
        positive: { surfaceColor: '#b3ffc7' },
        cautious: { surfaceColor: '#ffddb0' },
        informative: { surfaceColor: '#d0e4ff' },
        disabled: { surfaceColor: '#5e5e6214' },
      },
    },
    chip: {
      borderRadius: 8,
      filled: {
        surfaceColor: '#F9F7FF',
        borderColor: '#d2d8ea',
        iconColor: '#4e5057',
        textColor: '#4e5057',
        interactions: {
          hover: { surfaceColor: '#1b1b1f14' },
          pressed: { surfaceColor: '#1b1b1f1f' },
        },
        active: {
          surfaceColor: '#e1daff',
          borderColor: '#e1daff',
          iconColor: '#0a004a',
          textColor: '#0a004a',
          interactions: {
            hover: { surfaceColor: '#14005d14' },
            pressed: { surfaceColor: '#14005d1f' },
          },
        },
      },
      outline: {
        surfaceColor: '#ffffff',
        borderColor: '#d2d8ea',
        iconColor: '#4e5057',
        textColor: '#4e5057',
        interactions: {
          hover: { surfaceColor: '#1b1b1f14' },
          pressed: { surfaceColor: '#1b1b1f1f' },
        },
        active: {
          surfaceColor: '#e1daff',
          borderColor: '#e1daff',
          iconColor: '#0a004a',
          textColor: '#0a004a',
          interactions: {
            hover: { surfaceColor: '#14005d14' },
            pressed: { surfaceColor: '#14005d1f' },
          },
        },
      },
      small: { height: 32, paddingInline: 12 },
      medium: { height: 40, paddingInline: 16 },
      disabled: {
        surfaceColor: '#5E5E620A',
        textColor: '#b3b9d2',
        iconColor: '#b3b9d2',
      },
    },
  },
  name: 'Reckon web: Light',
  borderWidth: { standard: 1, large: 2 },
  breakpoints: { small: 576, medium: 768, large: 882, xlarge: 1200 },
  contentWidth: {
    xsmall: 480,
    small: 720,
    medium: 1024,
    large: 1200,
    xlarge: 1440,
  },
  elevation: {
    card: 100,
    dropdown: 200,
    sticky: 300,
    popover: 400,
    modal: 500,
    toast: 600,
  },
  shadow: {
    xsmall: '0px 1px 2px rgba(0, 0, 0, 0.2)',
    small: '0px 2px 4px rgba(0, 0, 0, 0.2)',
    medium: '0px 2px 8px rgba(0, 0, 0, 0.2)',
    large: '0px 4px 16px rgba(0, 0, 0, 0.2)',
    xlarge: '-8px 8px 32px rgba(0, 0, 0, 0.2)',
  },
  radii: {
    none: 0,
    xsmall: 4,
    small: 6,
    medium: 8,
    large: 12,
    xlarge: 16,
    full: 999,
  },
  semantic: {
    colour: {
      primary: {
        foreground: '#ffffff',
        background: '#5a3fff',
        container: {
          foreground: '#0a004a',
          background: '#e1daff',
          interactions: {
            hover: '#14005d14',
            focused: '#14005d1f',
            pressed: '#14005d29',
          },
        },
        inverse: {
          foreground: '#5a3fff',
          background: '#ffffff',
          interactions: {
            hover: '#5a3fff14',
            focused: '#5a3fff1f',
            pressed: '#5a3fff29',
          },
        },
        interactions: {
          hover: '#ffffff29',
          focused: '#ffffff36',
          pressed: '#ffffff42',
        },
      },
      secondary: {
        foreground: '#ffffff',
        background: '#e1daff',
        border: '#c0b7ff',
        container: {
          foreground: '#370e0c',
          background: '#fed4cf',
          interactions: {
            hover: '#370e0c14',
            focused: '#370e0c1f',
            pressed: '#370e0c29',
          },
        },
        inverse: {
          foreground: '#181a20',
          background: '#ffffff',
          interactions: {
            hover: '#5a3fff14',
            focused: '#5a3fff29',
            pressed: '#5a3fff29',
          },
        },
        interactions: {
          hover: '#ffffff29',
          focused: '#ffffff36',
          pressed: '#ffffff42',
        },
        accent: '#df322a',
      },
      neutral: {
        foreground: '#181a20',
        background: '#ffffff',
        border: '#d2d8ea',
        mono: { monotone: '#000000' },
        container: {
          foreground: '#4e5057',
          background: '#f4f5f7',
          interactions: {
            hover: '#1b1b1f14',
            focused: '#1b1b1f1f',
            pressed: '#1b1b1f29',
          },
        },
        inverse: {
          foreground: '#ffffff',
          background: '#4e5057',
          interactions: {
            hover: '#5e5e6214',
            focused: '#5e5e621f',
            pressed: '#5e5e6229',
          },
        },
        interactions: {
          hover: '#ffffff29',
          focused: '#ffffff36',
          pressed: '#ffffff42',
        },
      },
      reserved: {
        info: {
          foreground: '#ffffff',
          background: '#0062a0',
          container: {
            foreground: '#001d35',
            background: '#e9f1ff',
            interactions: {
              hover: '#001d3514',
              focused: '#001d351f',
              pressed: '#001d3529',
            },
          },
          inverse: {
            foreground: '#0062a0',
            background: '#ffffff',
            interactions: {
              hover: '#0062a014',
              focused: '#0062a01f',
              pressed: '#0062a029',
            },
          },
          interactions: {
            hover: '#ffffff29',
            focused: '#ffffff36',
            pressed: '#ffffff42',
          },
        },
        critical: {
          foreground: '#ffffff',
          background: '#c0000c',
          container: {
            foreground: '#410001',
            background: '#ffedea',
            interactions: {
              hover: '#41000114',
              focused: '#4100011f',
              pressed: '#41000129',
            },
          },
          inverse: {
            foreground: '#c0000c',
            background: '#ffffff',
            interactions: {
              hover: '#c0000c14',
              focused: '#c0000c1f',
              pressed: '#c0000c29',
            },
          },
          interactions: {
            hover: '#ffffff29',
            focused: '#ffffff36',
            pressed: '#ffffff42',
          },
        },
        warning: {
          foreground: '#ffffff',
          background: '#835500',
          container: {
            foreground: '#2a1800',
            background: '#ffeed9',
            interactions: {
              hover: '#2a180014',
              focused: '#2a18001f',
              pressed: '#2a180029',
            },
          },
          inverse: {
            foreground: '#835500',
            background: '#ffffff',
            interactions: {
              hover: '#83550014',
              focused: '#8355001f',
              pressed: '#83550029',
            },
          },
          interactions: {
            hover: '#ffffff29',
            focused: '#ffffff36',
            pressed: '#ffffff42',
          },
        },
        success: {
          foreground: '#ffffff',
          background: '#006d3b',
          container: {
            foreground: '#00210e',
            background: '#c2ffd0',
            interactions: {
              hover: '#00210e14',
              focused: '#00210e1f',
              pressed: '#00210e29',
            },
          },
          inverse: {
            foreground: '#006d3b',
            background: '#ffffff',
            interactions: {
              hover: '#006d3b14',
              focused: '#006d3b1f',
              pressed: '#006d3b29',
            },
          },
          interactions: {
            hover: '#ffffff29',
            focused: '#ffffff36',
            pressed: '#ffffff42',
          },
        },
      },
      surface: {
        neutral: {
          background: '#ffffff',
          background1: '#f4f5f7',
          background2: '#ECEFF9',
          background3: '#E6EAFA',
          background4: '#E0E4F8',
          foregroundPrimary: '#181a20',
          border: '#d2d8ea',
          borderStrong: '#b3b9d2',
        },
        primary: { background1: '#F9F7FF' },
        tonal: {
          background1: '#fffbfa',
          background2: '#fff7f4',
          background3: '#ffeee9',
          background4: '#fedfd8',
        },
      },
      text: {
        textPrimary: '#181a20',
        textBody: '#4e5057',
        textSecondary: '#6b6e7b',
        textTertiary: '#7e8190',
        textPlaceholder: '#6b6e7b',
        textHeadings: '#0a004a',
        textInverted: '#ffffff',
        textDisabled: '#b3b9d2',
        textLink: '#5a3fff',
        reserved: {
          info: '#0062a0',
          critical: '#c0000c',
          warning: '#835500',
          success: '#006d3b',
        },
      },
      decorative: {
        yellow: { foreground: '#1b1b1f', surface: '#ffca3a' },
        green: { foreground: '#ffffff', surface: '#12714d' },
        teal: { foreground: '#ffffff', surface: '#106f85' },
        blue: { foreground: '#ffffff', surface: '#1d6fea' },
        purple: { foreground: '#ffffff', surface: '#8246d4' },
        pink: { foreground: '#ffffff', surface: '#c31f83' },
        coral: { foreground: '#ffffff', surface: '#b94018' },
      },
    },
  },
  sizes: {
    xsmall: {
      fontSizeDisplay: '0.75rem',
      fontSizeText: '0.75rem',
      borderRadius: 4,
      boxSize: 24,
      gap: 4,
      paddingX: 8,
      paddingY: 2,
    },
    small: {
      fontSizeDisplay: '0.75rem',
      fontSizeText: '0.875rem',
      borderRadius: 6,
      boxSize: 32,
      gap: 8,
      paddingX: 12,
      paddingY: 4,
    },
    medium: {
      fontSizeDisplay: '1.125rem',
      fontSizeText: '1rem',
      borderRadius: 8,
      boxSize: 40,
      gap: 8,
      paddingX: 16,
      paddingY: 8,
    },
  },
  sizing: {
    xxsmall: 16,
    xsmall: 24,
    small: 32,
    base: 40,
    medium: 48,
    large: 56,
    xlarge: 72,
  },
  spacing: {
    none: 0,
    xxsmall: 2,
    xsmall: 4,
    small: 8,
    medium: 12,
    large: 16,
    xlarge: 24,
    xxlarge: 32,
    k3xlarge: 40,
  },
  typography: {
    fontFamily: {
      monospace:
        '"SFMono-Medium","SF Mono","Segoe UI Mono","Roboto Mono","Ubuntu Mono", Menlo, Consolas, Courier, monospace',
      body:
        'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
      heading:
        'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
    },
    fontSize: {
      xsmall: '0.75rem',
      small: '0.875rem',
      medium: '1rem',
      large: '1.125rem',
      xlarge: '1.25rem',
      xxlarge: '1.5rem',
      xxxlarge: '1.875rem',
      xxxxlarge: '2.25rem',
      xxxxxlarge: '3rem',
      xxxxxxlarge: '4rem',
    },
    fontWeight: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      heavy: 800,
    },
    leading: { tighter: 1, tight: 1.2, base: 1.4, loose: 1.6, looser: 1.8 },
  },
};
